/* istanbul ignore file */
// This is polyfill for older versions of browsers where Object.hasOwn is not supported
// In the future there might be a need to include more stuff for polyfill
import 'core-js/es/object/has-own';

import { APP_ROOT_ELEMENT_ID } from './constants';

async function init() {
  const rootElement = document.getElementById(APP_ROOT_ELEMENT_ID);

  if (!rootElement) {
    throw new Error(`Element #${APP_ROOT_ELEMENT_ID} was not found!`);
  }

  const appRender = await import('./appRender');

  void appRender.render(rootElement);
}

init().catch((error) => {
  throw error;
});
